import Paper from '@mui/material/Paper'
import TableContainer from '@mui/material/TableContainer'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableRow from '@mui/material/TableRow'
import TableCell from '@mui/material/TableCell'
import Typography from '@mui/material/Typography'
import { SxProps, Theme } from '@mui/material/styles'
import { formattedAmount } from '@/utils/stripeUtils'

export interface FlatFeeQuoteProps {
  payableAmount: number
  discount: number
  filingAndOtherFees?: number
  discountTotal: number
  subtotal: number
  total: number
  details: string
  sx: SxProps<Theme>
}

const FlatFeeQuote = ({
  payableAmount,
  discount,
  filingAndOtherFees,
  discountTotal,
  subtotal,
  total,
  details,
  sx = {},
}: FlatFeeQuoteProps) => {
  return (
    <TableContainer component={Paper} sx={sx}>
      <Table>
        <TableBody>
          <TableRow>
            <TableCell colSpan={2} sx={{ backgroundColor: '#f5f5f5' }}>
              <Typography
                variant="caption"
                data-testid="quoteDetails-description"
              >
                {details}
              </Typography>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              <Typography variant="caption">
                Law Firm's Standard Flat/Fix Fee for This Service:
              </Typography>
            </TableCell>
            <TableCell align="right">
              <Typography
                component="span"
                variant="caption"
                data-testid="payableAmount"
              >
                ${formattedAmount(payableAmount)}
              </Typography>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>
              <Typography variant="caption">
                LegalFix Member Discount ({discount * 100}%):
              </Typography>
            </TableCell>
            <TableCell align="right">
              <Typography variant="caption" data-testid="discount">
                -${formattedAmount(discountTotal)}
              </Typography>
            </TableCell>
          </TableRow>
          {filingAndOtherFees !== undefined && filingAndOtherFees !== 0 && (
            <>
              <TableRow>
                <TableCell>
                  <Typography variant="caption">
                    Subtotal Before Filing & Other Fees:
                  </Typography>
                </TableCell>
                <TableCell align="right">
                  <Typography variant="caption" data-testid="subtotal">
                    ${formattedAmount(subtotal)}
                  </Typography>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  <Typography variant="caption">
                    Filing & Other Fees:
                  </Typography>
                </TableCell>
                <TableCell align="right">
                  <Typography variant="caption" data-testid="subtotal">
                    ${formattedAmount(filingAndOtherFees)}
                  </Typography>
                </TableCell>
              </TableRow>
            </>
          )}
          <TableRow>
            <TableCell>
              <Typography variant="h3">Total:</Typography>
            </TableCell>
            <TableCell>
              <Typography
                variant="subtitle1"
                align="right"
                aria-label="Quote total"
                color="#000"
                data-testid="total"
              >
                ${formattedAmount(total)}
              </Typography>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  )
}
export default FlatFeeQuote
